import "./App.css";
import Router from "./views/Router";

const App = () => {
  return <Router />;
};

export default App;
